import { api } from "../../../../services/api";

export async function getOrderInfos(companyId) {
  const { data } = await api.get(`/getOrder/${companyId}`);
  return data;
}
